import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=fc21bae6&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"
import style0 from "./Tags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc21bae6')) {
      api.createRecord('fc21bae6', component.options)
    } else {
      api.reload('fc21bae6', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=fc21bae6&", function () {
      api.rerender('fc21bae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tag/Tags.vue"
export default component.exports